export default {
	goHome: "Retourner à l'accueil",
	message: "Rien n'a été trouvé ici...",
};
